import { render, staticRenderFns } from "./dupla-conferencia.vue?vue&type=template&id=793a6858"
import script from "./dupla-conferencia.vue?vue&type=script&lang=js"
export * from "./dupla-conferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports